<template>
    <section v-if="hasPermissions(['Utilities-Recycle-Bin Read'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1" v-html="title_page"/>
        <div class="view__description">
            <p class="view__description__text">
                Here you can bring back a deleted item. After 30 days items are permanently deleted.
            </p>
        </div>

        <div class="bar-container-recycle">
            <div class="bar-container-recycle__search-bar">
                <div class="input-field my-0">
                    <i class="material-icons prefix iconInput">search</i>
                    <input id="icon_prefix" type="text" class="validate inputSearch" placeholder="Search" v-model="search">
                </div>
            </div>
            <div class="bar-container-recycle__options">
                <button v-if="hasPermissions(['Utilities-Recycle-Bin Write'])" class="modal__buttons__item w-auto mr-1 px-3"  v-html="'Restore'" :class="{'disabled button__disabled' : !selected}" :disabled="!selected" @click="massive_modal_action(true)"></button>
                <button v-if="hasPermissions(['Utilities-Recycle-Bin Write'])" class="modal__buttons__item w-auto px-3" v-html="'Permanently delete'" :class="{'disabled button__disabled' : !selected}" :disabled="!selected" @click="massive_modal_action(false)"/>
            </div>
        </div>
        
        <div class="tab-content">
            <div class="row mb-0">
                <div class="py-lg-0 col-md-12">
                    <div class="card cardModuleM h-100">
                        <div class="card-content h-100 d-md-flex align-items-md-center">
                            <div class="row mb-0 no-gutters horizontal-scroll-reports">
                                <div class="col-lg-2 collection listColection">
                                    <h6 class="random-title" v-html="title_page"/>
                                    <a 
                                        v-for="(item, i) in system_list" :key="i" 
                                        :class="`collection-item list-colection-item ${recycle_render === item.identify ? 'list-colection-item-selected' : ''}`"
                                        :style="`font-weight:bold; text-decoration:none;`"
                                        v-html="item.name"
                                        :href="`#${item.identify}`"
                                        @click="RecycleRender(item.identify)"
                                    />
                                </div>
                                <!-- <div class="col-lg-10 verticalLine center-align horizontal-scroll-reports"> -->
                                <div class="col-lg-10 horizontal-scroll-reports">
                                    <div class="row mb-0 no-gutters">
                                        <div class="col-lg-12">
                                            <DinamicTable
                                                :headers="table_headers"
                                                :items="display_items"
                                                :search="search"
                                                :checkable="true"
                                                :selectable_columns="false"
                                                :link="'report/'"
                                                :margin_left="'margin-left:10px'"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <ModalConfirmation
            @objectDeletion="massive_local_emition($event)"
            :action_restore="action_restore"
        />

        <ValidationModal
        :validate_data="logs"
        :breadcrumb="breadcrumb"
        />


        <WaitingModal/>
        

    </section>

    <div v-else>
        <UnauthorizedComponent :breadcrumb="breadcrumb"/>
    </div>

</template>

<script>
import axios                from    'axios';
import Breadcrumb           from    '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal         from    '@/components/WaitingModal'
import Resources            from    './resources'
import ModalConfirmation    from    './ModalConfirmation'
import ValidationModal    from    './ValidationModal'
import DinamicTable         from    '@/components/DinamicTable'
import UnauthorizedComponent from   '@/components/UnauthorizedComponent'
import 'vuetify/dist/vuetify.min.css'

import { Notyf }            from    'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});
export default {

    name: "RecycleBin",

    components: {
        Breadcrumb,
        WaitingModal,
        DinamicTable,
        ModalConfirmation,
        ValidationModal,
        UnauthorizedComponent
    },

    data() {
        return {
            notyf,
            axios,
            user:               this.get_user(),
            title_page:         'Recycle Bin',
            rest_api:           `recycle_bin`,
            table_headers:      Resources.table_headers,
            breadcrumb:         Resources.breadcrumb,
            system_list:        Resources.system_list,
            single_select:      false,
            table_selection:    [],
            search:             '',
            global_index:       null,
            single_object:      {},
            recyclce_bin_items: [],
            logs: [],
            array_options:      {},
            report_render:      'all',


            table_selection_test:   [],
            table_headers_test:     Resources.table_headers_test,
            single_select_test:     {},
            search_test:            '',
            histories:              [],
            history_title:          '',
            select_ids:             [],
            action_restore:         false,
            recycle_render:         'all',
        };
    },
    
    computed:
    {
        selected()
        {
            const bool = this.recyclce_bin_items.filter(item => item.checked)
            return Boolean(bool.length)
        },
        display_items()
        {
            if(this.recycle_render === 'buildings')
            {
                return  this.recyclce_bin_items.filter(
                            item => item.module_name === 'Buildings' || 
                                    item.module_name === 'Levels' || 
                                    item.module_name === 'Areas' ||
                                    item.module_name === 'Rooms' ||
                                    item.module_name === 'Cost Centers' ||
                                    item.module_name === 'Cost Center Departments' ||
                                    item.module_name === 'Cost Center Personnel' ||
                                    item.module_name === 'Room Types'
                        )
            }
            else if(this.recycle_render === 'associates')
            {
                return  this.recyclce_bin_items.filter(
                            item => item.module_name === 'Associates' || 
                                    item.module_name === 'Positions' || 
                                    item.module_name === 'Contact Types'
                        )

            }
            else if(this.recycle_render === 'assignments')
            {
                return  this.recyclce_bin_items.filter(
                            item => item.module_name === 'Daily Assignments' || 
                                    item.module_name === 'Shifts' || 
                                    item.module_name === 'Tasks' ||
                                    item.module_name === 'Projects' ||
                                    item.module_name === 'Service Requests'
                        )

            }
            else if(this.recycle_render === 'budgeting')
            {
                return  this.recyclce_bin_items.filter(item => item.module_name === 'Staffing Scenarios')
            }
            else if(this.recycle_render === 'census')
            {
                return  this.recyclce_bin_items.filter(
                            item => item.module_name === 'Log Productivity')
            }
            else if(this.recycle_render === 'daysoff')
            {
                return  this.recyclce_bin_items.filter(
                            item => item.module_name === 'Schedule Templates' || 
                                    item.module_name === 'Live Schedules' || 
                                    item.module_name === 'Rotation Setup'
                        )
            }
            else if(this.recycle_render === 'qc')
            {
                return  this.recyclce_bin_items.filter(
                            item => item.module_name === 'Inspection Templates' || 
                                    item.module_name === 'Template Inspections' ||
                                    item.module_name === 'Instant Inspections' ||
                                    item.module_name === 'Inspection Template Steps' || 
                                    item.module_name === 'Surveys' ||
                                    item.module_name === 'Survey Questions'
                        )
            }
            else if(this.recycle_render === 'options')
            {
                return  this.recyclce_bin_items.filter(
                            item => item.module_name === 'Step Codes' || 
                                    item.module_name === 'Bed Codes' || 
                                    item.module_name === 'Inspection Items' || 
                                    item.module_name === 'Groups' ||
                                    item.module_name === 'Floors' ||
                                    item.module_name === 'Specialities' || 
                                    item.module_name === 'Time offs' 
                        )
            }
            else if(this.recycle_render === 'reports')
            {
                return  this.recyclce_bin_items.filter(
                            item => item.module_name === 'Reports')
            }
            return this.recyclce_bin_items
        }
    },

    methods: {
         RecycleRender(choosen_render)
        {
            this.recycle_render = choosen_render;
            return this.report_render === 'all' ? 'all' : this.report_render
        },

        unshift_object(new_object)
        {
            this.recyclce_bin_items.unshift(new_object)
        },

        splice_object(splicing_object)
        {
            this.recyclce_bin_items.splice(splicing_object.index, 1, splicing_object.single_object)
        },

        form_modal()
        {
            if(!this.user.has_facility){
                notyf.error('There is not exists a facility yet')
                return false
            }
            window.$('#static').modal('show')
        },

        modal_deletion(index)
        {
            this.global_index  = index
            this.single_object = this.recyclce_bin_items[index]
            window.$('#static-deletion-massive').modal('show')
        },

        modal_update(index)
        {
            this.global_index  = index
            this.single_object = this.recyclce_bin_items[index]
            window.$('#static-update').modal('show')
        },

        fill_data(data)
        {
            this.recyclce_bin_items = data.recycle_bin_items
        },

        trashing(index)
        {
            this.recyclce_bin_items.splice(index, 1)
        },


        massive_modal_action(action_restore)
        {
            this.select_ids = this.recyclce_bin_items.filter(item => item.checked).map(item => item)
            this.action_restore = action_restore

            if(this.select_ids.length)
            {
                window.$('#static-massive-action').modal('show')
            }
        },

        async massive_local_emition()
        {
            let json_request = {
                ids: this.select_ids,
                action_restore: this.action_restore,
            }

            this.loader(true);
            let sendingMassive = await this.postingByPost(this.rest_api + '/massive_action', json_request)

            if(sendingMassive.status)
            {
                window.$('#static-massive-action').modal('hide')
                const logs = sendingMassive.data.logs
                if(logs.length)
                {
                    window.$('#validations').modal('show')
                    this.logs = logs;
                }
                this.api_request();
                this.select_ids = []
            }
            this.loader();
        },
        
    },

    async mounted()
    {
        if(this.hasPermissions(['Utilities-Recycle-Bin Read']))
        {
            await this.api_request()
        }
    },

}
</script>
